/**
 @ngdoc service
 @name tileDataFactory
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var tileDataFactory = function($filter) {

        const HISTORY_TILE = {
            PRIORITY_LIST: ['actionedByPersonName', 'actionedByOrgName', 'actionedByIpAddress', 'logActionType', 'universalId'],
            COMMON_USED_FIELD_LIST: ['type', 'occurredOn','messageBody']
        };

        //In case in the future these css bootstrap styles change
        const CSS_CLASS = {
            DEFAULT: 'default',
            SUCCESS: 'success',
            DANGER: 'danger',
            WARNING: 'warning',
            INFO: 'info',
            HIDDEN: 'hidden'
        };

        var COLUMN1 = 0;
        var COLUMN2 = 1;
        var COLUMN3 = 2;
        var COLUMN4 = 3;
        var FULL_WIDTH_ROW = 4;

        var constructTileData = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;
            // Defining the tile data structure
            this.tileData = {
                /**
                 * 'labels' are the tile's displayed fields. The array's index from labels[0] to labels[3], are the 4 columns from left to right.
                 * Array index labels[4] is the full width column. Fields added to an individual's array are displayed from top to bottom.
                 */
                labels: [
                    [],[],[],[],[]
                ],
                status: [],
                stageCollection: [],
                callToAction: [],
                searchMatchFlag: [],
                textField: [],
                historyTimeStamp: {},
                historyTile: rawTileData.historyTile
            };

            // Categories of raw data used within factory
            this.objectTilesLabels = objectTilesLabels;
            this.rawTileData = rawTileData;
            this.commonLabels = commonLabels;
            this.requesterData = requesterData;

            if(lookupValues===undefined){
                throw "lookupValues is undefined";
                //return;
            }
            this.lookupValues = lookupValues;

            // A reference to the constant
            this.CSS_CLASS = CSS_CLASS;

            /**
             * Adds all the field for all keys that have a label and data
             * @param rawTileData
             * @param objectTilesLabels
             * @param usedFieldKeys
             * @param suggestedPriorityKeyList
             * @return lastColumnIndex COLUMN1 COLUMN2 COLUMN3 COLUMN4
             */
            this.addAllFieldsWithLabels = function (rawTileData, objectTilesLabels, usedFieldKeys, suggestedPriorityKeyList) {
                //console.log('addAllFieldsWithLabels(rawTileData, objectTilesLabels, usedFieldKeys, suggestedPriorityKeyList)',rawTileData, objectTilesLabels, usedFieldKeys, suggestedPriorityKeyList);
                var priorityKeyList = [], nonPriorityKeyList = [];
                //Checks the list are actually present in data
                for (var key in rawTileData) {
                    //check if not excluded
                    if (!usedFieldKeys.includes(key)) {
                        if (!suggestedPriorityKeyList.includes(key)) {
                            nonPriorityKeyList.push(key);
                        }
                    }
                }
                nonPriorityKeyList.sort();
                //checks suggested priority keys exist
                for (var keyIdx in suggestedPriorityKeyList) {
                    var suggestedPriorityKey = suggestedPriorityKeyList[keyIdx];
                    if(!usedFieldKeys.includes(suggestedPriorityKey) && rawTileData[suggestedPriorityKey]){
                        priorityKeyList.push(suggestedPriorityKey);
                    }
                }
                //console.log('priorityKeyList',priorityKeyList,'nonPriorityKeyList',nonPriorityKeyList);
                var lastColumnIndex = -1;
                lastColumnIndex = self.addAllFieldsWithLabelsFromList(priorityKeyList, objectTilesLabels, lastColumnIndex);
                lastColumnIndex = self.addAllFieldsWithLabelsFromList(nonPriorityKeyList, objectTilesLabels, lastColumnIndex);
                lastColumnIndex = self.addFieldChangeList(lastColumnIndex);
                //Added this here as multiple object can have a email/sms body/content
                self.addTextField(self.textField.newTextField('messageBody'));
                return lastColumnIndex;
            };

            /**
             * History tiles have old to new value fields - This method parses them for diaplay
             * @param columnIndex
             * @returns {*}
             */
            this.addFieldChangeList = function(columnIndex){
                var fieldChangeList = self.rawFieldValue('fieldChangeList');
                //console.log('addFieldChangeList() fieldChangeList',fieldChangeList);
                var keyIdx, fieldChange, fieldObject;
                for (keyIdx in fieldChangeList) {
                    fieldChange = fieldChangeList[keyIdx];
                    if(fieldChange){
                        columnIndex = self.moveToNextColumn(columnIndex);
                        // note: If any specific logic is required here, write the condition testing against the 'fieldChange.i18n.code' value as it is a static value.
                        if (fieldChange.hideUpdatedValue == true) {
                            fieldObject = {label: fieldChange.i18n.label, value: 'updated'};
                        } else {
                            fieldObject = {label: fieldChange.i18n.label, value: fieldChange.oldValue+' » '+fieldChange.newValue};
                        }

                        console.log('fieldObject',fieldObject);
                        self.addFieldToColumn(fieldObject, columnIndex);
                    }
                }
                return columnIndex;
            };

            /**
             *
             * @param rawTileDataKeys
             * @param objectTilesLabels
             * @param lastColumnIndex
             * @return lastColumnIndex COLUMN1 COLUMN2 COLUMN3 COLUMN4
             */
            this.addAllFieldsWithLabelsFromList = function (rawTileDataKeys, objectTilesLabels, lastColumnIndex) {
                // Listing all the fields for any column layout
                for (var keyIdx in rawTileDataKeys) {
                    var key = rawTileDataKeys[keyIdx];
                    if (!key.includes('URI') && objectTilesLabels[key] != undefined && objectTilesLabels[key].label != '') {
                        //console.log('rawTileData', rawTileData.title, 'addFieldToAnyColumn(key, lastColumnIndex)', key, lastColumnIndex)
                        lastColumnIndex = self.addFieldToAnyColumn(key, lastColumnIndex);
                    }
                }
                return lastColumnIndex;
            };

            this.moveToNextColumn = function(columnIndex){
                columnIndex++;
                if(columnIndex > COLUMN4){
                    columnIndex = 0;
                }
                return columnIndex;
            };

            /**
             *
             * @param fieldKey
             * @param lastColumnIndex
             * @return lastColumnIndex COLUMN1 COLUMN2 COLUMN3 COLUMN4
             */
            this.addFieldToAnyColumn = function(fieldKey, columnIndex) {
                var fieldType = this.getFieldType(fieldKey);
                columnIndex = self.moveToNextColumn(columnIndex);
                var fieldObject;
                // Setting field formats based on field types
                if(fieldType == 'DATE'){
                    fieldObject = this.field.newField(fieldKey,'date');
                } else if(fieldType == 'BOOLEAN'){
                    fieldObject = this.field.newFieldBooleanYesOrNo(fieldKey);
                } else {
                    var possibleLinkKey = fieldKey+'URI';
                    if(self.rawFieldValue(possibleLinkKey)){
                        fieldObject = this.field.newLinkField(fieldKey,possibleLinkKey);
                    } else {
                        fieldObject = this.field.newField(fieldKey);
                    }
                }
                //console.log(fieldObject,columnIndex);
                this.addFieldToColumn(fieldObject, columnIndex);
                return columnIndex;
            };

            // Function that returns field type
            this.getFieldType = function(fieldKey) {
                var type = '';
                if(objectTilesLabels[fieldKey]){
                    type = objectTilesLabels[fieldKey].fieldType;
                }
                //console.log('fieldKey', fieldKey, type);
                return type;
            };

            this.addFieldToColumn = function(fieldObject, column){
                if(fieldObject) {
                    this.tileData.labels[column].push(fieldObject);
                }
            };

            this.addFieldToColumn1 = function(fieldObject){
                this.addFieldToColumn(fieldObject, COLUMN1);
            };

            this.addFieldToColumn2 = function(fieldObject){
                this.addFieldToColumn(fieldObject, COLUMN2);
            };

            this.addFieldToColumn3 = function(fieldObject){
                this.addFieldToColumn(fieldObject, COLUMN3);
            };

            this.addFieldToColumn4 = function(fieldObject){
                this.addFieldToColumn(fieldObject, COLUMN4);
            };

            this.addFieldToFullWidthRow = function(fieldObject){
                this.addFieldToColumn(fieldObject, FULL_WIDTH_ROW);
            };

            // Adding status object to tile data
            this.addStatus = function(statusObject){
                statusObject ? this.tileData.status.push(statusObject) : '';
            };

            // Adding status object to tile data
            this.addStageCollection = function(stageCollectionObject){
                stageCollectionObject ? this.tileData.stageCollection.push(stageCollectionObject) : '';
            };

            // Adding call to action object to tile data
            this.addCallToAction = function(callToActionObject){
                callToActionObject ? this.tileData.callToAction.push(callToActionObject) : '';
            };

            // Adding search match flag object to tile data
            this.addSearchMatchFlag = function(searchMatchFlagObject){
                searchMatchFlagObject ? this.tileData.searchMatchFlag.push(searchMatchFlagObject) : '';
            };

            // Adding call to action object to tile data
            this.addTextField = function(textFieldObject){
                textFieldObject ? this.tileData.textField.push(textFieldObject) : '';
            };

            // Adding call to action history time stamp
            this.addHistoryTimeStamp = function(dateObject){
                if(dateObject)
                    this.tileData.historyTimeStamp = dateObject;
            };

            // collects the raw field value
            this.rawFieldValue = function(dataKey){
                if(!dataKey) console.warn('IllegalArgumentException: dataKey must not be null');
                if(typeof dataKey !== 'string') console.error('IllegalArgumentException: dataKey must be a string');
                if(!dataKey in self.rawTileData) console.error('IllegalArgumentException: dataKey is not present in self.rawTileData',
                  {'dataKey': dataKey, 'self.rawTileData': self.rawTileData});
                return self.rawTileData[dataKey];
            };

            //If the dataField key is present, display the field. This is the case even if value of that key is null.
            //If the dataField key is NOT present, do not display the field
            this.rawFieldValuePresent = function(rawFieldValue){
                return (rawFieldValue!==undefined);
            };
            this.rawFieldValueNotEmpty = function(rawFieldValue){
                return (rawFieldValue!==null);
            };
            this.rawFieldValueEmpty = function(rawFieldValue){
                return (rawFieldValue===null);
            };
            this.rawFieldValuePresentAndNotEmpty = function(rawFieldValue){
                return (self.rawFieldValuePresent(rawFieldValue) && self.rawFieldValueNotEmpty(rawFieldValue));
            };
            this.setRawFieldValueToZero = function(dataKey, nullToZero){
                if(nullToZero){
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    if( self.rawFieldValueEmpty(rawFieldValue) ){
                        self.setRawFieldValue(dataKey,0);
                    }
                }
            };
            this.lookupField = function(typeDataKey){
                var rawFieldValue = self.rawFieldValue(typeDataKey);
                if( self.rawFieldValuePresentAndNotEmpty(rawFieldValue) ){
                    return {
                        lookupKey:  rawFieldValue.lookupKey,
                        id:         rawFieldValue.id,
                        value:      self.lookupValues[rawFieldValue.lookupKey][rawFieldValue.id]
                    };
                }
                return null;
            };
            // ideally would like to remove all these calls
            this.setRawFieldValue = function(dataKey, value){
                self.rawTileData[dataKey] = value;
            };
            // collects a basic label
            this.objectFieldLabel = function(dataKey){
                if(self.objectTilesLabels[dataKey]){
                    return self.objectTilesLabels[dataKey].label
                } else {
                    console.warn('Unable to find dataKey dataKey "'+dataKey+'" objectTilesLabels. Available keys:',Object.keys(self.objectTilesLabels))
                }
                return 'Undefined:'+dataKey;
            };
            //useful property to identify if business model is principal or corporate
            this.isPrincipal = function(){
                return ( self.rawFieldValue('businessModel')==='principal');
            };

            /**
             * Adds icon to field
             * @param {string} path The path of the icon svg
             * @param {string} icon The id of the icon to be used
             * @param {any} newFieldObj The field data
             * @param {boolean} [iconOnly=false] If only the icon is to be displayed
             * @returns {any}
             */
            this.addIcon = (path, icon, newFieldObj, iconOnly = false, iconAfterLabel = false) => {
                newFieldObj.icon = `${path}${icon}`
                newFieldObj.iconAfterLabel = iconAfterLabel
                newFieldObj.iconOnly = iconOnly
                return newFieldObj
            },

            this.separator = {
                standard: function (separatorOverride, separatorStandard) {
                    if (separatorOverride === undefined) {
                        return separatorStandard;
                    } else {
                        return separatorOverride;
                    }
                },
                // Uses provided separator or uses default person name separator of ' '
                personName: function (separatorOverride) {
                    return this.standard(separatorOverride, ' ');
                },
                // Uses provided separator or uses value & type separator of ' '
                valueAndType: function (separatorOverride) {
                    return this.standard(separatorOverride, ' ');
                },
                // Uses provided separator or uses default list separator of ', '
                list: function (separatorOverride) {
                    return this.standard(separatorOverride, ', ');
                },
                // Uses provided separator or uses default range separator of ' - '
                range: function (separatorOverride) {
                    return this.standard(separatorOverride, ' - ');
                },
                // Uses provided separator or uses default fraction separator of '/'
                fraction: function (separatorOverride) {
                    return this.standard(separatorOverride, '/');
                },
                // Uses provided separator or uses key value separator of ': '
                keyValue: function (separatorOverride) {
                    return this.standard(separatorOverride, ': ');
                }
            };

            // Object that holds field creation methods
            this.field = {

                newFieldToColumn: function (dataKey, column, formatFunction) {
                    self.addFieldToColumn(this.newField(dataKey, formatFunction), column);
                },

                // Creating new field object
                newField: function (dataKey, formatFunction) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    //If dateFormat has been setup in the getTile method, use it, else default to English Format
                    var dateFormat = self.rawTileData.dateFormat ? self.rawTileData.dateFormat : undefined
                    // Add lookup value to new fields value if lookup key exists
                    if(self.rawFieldValuePresent(rawFieldValue)){
                        var fieldLabel = self.objectFieldLabel(dataKey);

                        if(formatFunction === 'date' || formatFunction === 'dateTime'){
                            var fieldValue = formatFunction ? eval(formatFunction + '(rawFieldValue, dateFormat)') : rawFieldValue;
                        } else {
                            var fieldValue = formatFunction ? eval(formatFunction + '(rawFieldValue)') : rawFieldValue;
                        }
                        if( self.rawFieldValueNotEmpty(rawFieldValue) && rawFieldValue.hasOwnProperty('lookupKey')) {
                            fieldValue = self.lookupValues[rawFieldValue.lookupKey][rawFieldValue.id];
                        }
                        if (fieldLabel === ''){
                            var businessModel = self.rawFieldValue('businessModel');
                            if( businessModel ){
                                console.warn('Warning: Empty label for "' + dataKey + '" dataList key, "' + businessModel + '" businessModel');
                            }else{
                                console.warn('Warning: Empty label for "' + dataKey + '" dataList key');
                            }
                        }
                        return {
                            label: fieldLabel,
                            testId: fieldLabel.replace(/\s/g,'-').toLowerCase(),
                            value: fieldValue,
                        }
                    }else{
                        console.warn('Warning: Missing dataKey "' + dataKey + '" in dataList, cannot use newField method');
                    }
                },

                // Creating value with currency field object
                newFieldWIthDefinedLabel: function (dataKey, labelKey) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj){
                        newFieldObj.label = self.rawFieldValue(labelKey);
                    }
                    return newFieldObj;
                },

                // Creating value with currency field object
                newValueWithCurrencyField: function (dataKey) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj){
                        newFieldObj.value = $filter('currency')(newFieldObj.value, self.requesterData.currencySymbol)
                    }
                    return newFieldObj;
                },

                newDateTimeRangeField: function (dateStartKey, dateEndKey, separatorOverride) {
                    var newFieldObj = this.newField(dateStartKey);
                    if (newFieldObj){
                        newFieldObj.value = dateTime(self.rawTileData[dateStartKey]) + self.separator.range(separatorOverride) + dateTime(self.rawTileData[dateEndKey]);
                        newFieldObj.value = dateTime(self.rawTileData[dateStartKey]) + ' - ' + dateTime(self.rawTileData[dateEndKey]);
                    }
                    return newFieldObj;
                },

                newDateRangeField: function(dateStartKey, dateEndKey, separatorOverride){
                    var startDate = this.newField(dateStartKey, 'date');
                    var endDate = this.newField(dateEndKey, 'date');
                    if(endDate){
                        startDate.value += self.separator.range(separatorOverride) + endDate.value;
                    }
                    return startDate;
                },

                // Creating field with additional information object
                newProgressField: function (progressKey, totalKey, linkKey, separatorOverride) {
                    var newFieldObj = this.newField(progressKey);
                    if(newFieldObj) {
                        newFieldObj.value = self.rawFieldValue(progressKey) + self.separator.fraction(separatorOverride) + self.rawFieldValue(totalKey);
                        linkKey ? newFieldObj = linkKey : '';
                    }
                    return newFieldObj;
                },

                newEmailLink: email => {
                    return `mailto:${email}`
                },

                newPhoneLink: dataKey => {
                    return 'tel:' + self.rawFieldValue(dataKey)
                },

                // Creating new field with inactive styling
                newInactiveField: function (dataKey, inactiveKey, additionalInfoKey, popModal) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj && newFieldObj.value) {
                        var rawFieldValue = self.rawFieldValue(inactiveKey);
                        newFieldObj.inactive = rawFieldValue;
                        if (rawFieldValue) {
                            newFieldObj.additionalInfo = self.objectTilesLabels[additionalInfoKey].label;
                        }
                        // used to display clickable phone link
                        newFieldObj.link = this.newPhoneLink(dataKey);
                        if (popModal) newFieldObj.popModal = self.rawFieldValue(popModal);
                    }
                    return newFieldObj;
                },
                // Creating new field with inactive styling And ajax
                newInactiveFieldAjax: function (dataKey, inactiveKey, additionalInfoKey, popModal, ajaxUrl) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj && newFieldObj.value) {
                        var rawFieldValue = self.rawFieldValue(inactiveKey);
                        newFieldObj.inactive = rawFieldValue;
                        if (rawFieldValue) {
                            newFieldObj.additionalInfo = self.objectTilesLabels[additionalInfoKey].label;
                        }
                        // used to display clickable phone link
                        newFieldObj.link = this.newPhoneLink(dataKey);
                        if (ajaxUrl) {
                          newFieldObj.ajaxUrl = self.rawFieldValue(ajaxUrl);
                          var teamsCalling = self.rawFieldValue(dataKey + 'TeamsCalling');
                          if (teamsCalling) {
                            newFieldObj.showTeamsCallingIcon = teamsCalling.showTeamsCallingIcon;
                            newFieldObj.teamsCallingIconColour = teamsCalling.teamsCallingIconColour;
                            newFieldObj.teamsCallingTooltip = teamsCalling.teamsCallingTooltip;
                            console.log(newFieldObj.teamsCallingIconColour );
                          }
                        }
                        if (popModal) newFieldObj.popModal = self.rawFieldValue(popModal);
                    }
                    return newFieldObj;
                },

                //like above but is given a list of possible strike through properties ranked in order of priority
                newRankedInactiveField: function (dataKey, booleanAndAdditionalInfoKeyList, popModal) {
                    var inactiveKey = null;
                    var additionalInfoKey = null;

                    for (var i = 0, l = booleanAndAdditionalInfoKeyList.length; i < l; i++) {
                        inactiveKey = booleanAndAdditionalInfoKeyList[i][0];
                        additionalInfoKey = booleanAndAdditionalInfoKeyList[i][1];

                        if (self.rawFieldValue(inactiveKey)) {
                            break; //The first property to declare field inactive will be displayed
                        }
                    }
                    return this.newInactiveField(dataKey, inactiveKey, additionalInfoKey, popModal);
                },
                //like above but is given a list of possible strike through properties ranked in order of priority
                newRankedInactiveFieldAjax: function (dataKey, booleanAndAdditionalInfoKeyList, popModal, ajaxUrl) {
                    var inactiveKey = null;
                    var additionalInfoKey = null;

                    for (var i = 0, l = booleanAndAdditionalInfoKeyList.length; i < l; i++) {
                        inactiveKey = booleanAndAdditionalInfoKeyList[i][0];
                        additionalInfoKey = booleanAndAdditionalInfoKeyList[i][1];

                        if (self.rawFieldValue(inactiveKey)) {
                            break; //The first property to declare field inactive will be displayed
                        }
                    }
                    return this.newInactiveFieldAjax(dataKey, inactiveKey, additionalInfoKey, popModal, ajaxUrl);
                },

                // Field with warning and additionalInfo
                // args: dataKey, warningKeys - array of keys, returns first match where true
                newWarningField: function (dataKey, warningKeys) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj && newFieldObj.value) {
                        // loop through warning keys, return first true
                        for(var i = 0; i< warningKeys.length; i++){
                            var warningKey = warningKeys[i];
                            var rawFieldValue = self.rawFieldValue(warningKey);
                            newFieldObj.warning = rawFieldValue;
                            if (rawFieldValue) {
                                newFieldObj.warningType = warningKey;
                                break;
                            }
                        }
                    }
                    return newFieldObj;
                },

                newInactiveWarningField: function (dataKey, warningKeys, inactiveKey, additionalInfoKey, popModal) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj && newFieldObj.value) {
                        // loop through warning keys, return first true
                        for(var i = 0; i< warningKeys.length; i++){
                            var warningKey = warningKeys[i];
                            var rawFieldValue = self.rawFieldValue(warningKey);
                            newFieldObj.warning = rawFieldValue;
                            if (rawFieldValue) {
                                newFieldObj.warningType = warningKey;
                                break;
                            }
                        }
                        if(newFieldObj.warningType) {
                            return newFieldObj;
                        }
                    }
                    if(newFieldObj && newFieldObj.value) {
                        var rawFieldValue = self.rawFieldValue(inactiveKey);
                        newFieldObj.inactive = rawFieldValue;
                        if (rawFieldValue) {
                            newFieldObj.additionalInfo = self.objectTilesLabels[additionalInfoKey].label;
                        }
                    }
                    return newFieldObj;
                },

                // Creating field with additional information object
                newFieldWithAdditionalInfo: function (dataKey, additionalInfoKey) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj) {
                        newFieldObj.additionalInfo = self.rawFieldValue(additionalInfoKey);
                    }
                    return newFieldObj;
                },

                // Creating field with boolean values yes or no object
                newFieldBooleanYesOrNo: function (dataKey) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj) {
                        newFieldObj.value = self.rawFieldValue(dataKey) ? self.commonLabels.booleanYes.label : self.commonLabels.booleanNo.label;
                    }
                    return newFieldObj;
                },

                // Creating new time field object
                newTimeField: function (dataKey) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj) {
                        newFieldObj.value = '';
                        var rawFieldValue = self.rawFieldValue(dataKey);
                        if ( self.rawFieldValueNotEmpty(rawFieldValue) ) {
                            //if unit is defined add - works because newFieldObj is an object
                            var addUnit = function (unit, newFieldObj, unitLabel) {
                                if (unit !== undefined) {
                                    newFieldObj.value += unit + unitLabel + ' ';
                                }
                            };
                            addUnit(rawFieldValue.days, newFieldObj, self.commonLabels.dayShort.label);
                            addUnit(rawFieldValue.hours, newFieldObj, self.commonLabels.hourShort.label);
                            addUnit(rawFieldValue.minutes, newFieldObj, self.commonLabels.minuteShort.label);
                        }
                    }
                    return newFieldObj;
                },

                // Appends each line of an address to field Object
                // {value: 'Town Name, United Kingdom', additionalInfo: 'line1', 'line2', 'town', 'county', 'postCode', 'country'}
                appendAddressKeys: function(dataKey, propertyKeyList, displayPropertyKeyList, separatorOverride) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj) {
                        var rawFieldValue = self.rawFieldValue(dataKey);
                        if ( self.rawFieldValueNotEmpty(rawFieldValue) ) {
                            //newFieldObj.value = undefined;
                            newFieldObj.value = '';
                            newFieldObj.additionalInfo = '';
                            var listSeparator = self.separator.list(separatorOverride);
                            propertyKeyList.forEach(function (propertyKey) {

                                var propertyValue;

                                if (!Array.isArray(rawFieldValue)) {
                                    //Singular address object
                                    propertyValue = rawFieldValue[propertyKey];
                                } else {
                                    //Array of address objects
                                    if (rawFieldValue.length > 1) {
                                        newFieldObj.value = self.commonLabels.multiple.label;
                                        propertyValue = undefined;
                                    } else {
                                        propertyValue = rawFieldValue[0][propertyKey];
                                    }
                                }

                                if (propertyValue) {
                                    // Listing keys for address value
                                    if (displayPropertyKeyList.includes(propertyKey)) {
                                        // Adding separator
                                        if (newFieldObj.value !== '') {
                                            newFieldObj.value += listSeparator;
                                        }
                                        newFieldObj.value += propertyValue;
                                    }
                                    // Adding separator
                                    if (newFieldObj.additionalInfo !== '') {
                                        newFieldObj.additionalInfo += listSeparator;
                                    }
                                    newFieldObj.additionalInfo += propertyValue;
                                }

                            })
                        }
                    }
                    return newFieldObj;
                },

                newAddressField: function (dataKey) {
                    return this.appendAddressKeys(
                        dataKey,
                        ['line1', 'line2', 'town', 'county', 'postCode', 'country'],
                        ['town', 'country']
                    );
                },

                // Creating new multiple field with address array
                newMultipleAddressField: function (dataKey) {
                    return this.appendAddressKeys(
                        dataKey,
                        ['line1', 'line2', 'town', 'county', 'postCode', 'country'],
                        ['line1', 'town', 'country']
                    );
                },

                // Creating new multiple field with link object
                newMultipleFieldWithLink: function (dataKey, linkKey, separatorOverride) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj) {
                        var rawFieldValue = self.rawFieldValue(dataKey);
                        if (Array.isArray(rawFieldValue)) {
                            if (rawFieldValue.length > 1) {
                                var listSeparator = self.separator.list(separatorOverride);
                                for (var i in rawFieldValue) {
                                    var value = rawFieldValue[i];
                                    newFieldObj.additionalInfo = newFieldObj.additionalInfo ? newFieldObj.additionalInfo + listSeparator + value : value;
                                }
                                newFieldObj.value = rawFieldValue[0] + " (" + self.commonLabels.multiple.label + ")";
                                newFieldObj.link = null;
                                if(linkKey!=null) {
                                    newFieldObj.link = self.rawFieldValue(linkKey)[0];
                                }
                            } else {
                                newFieldObj.value = rawFieldValue[0];
                                if(linkKey!=null) {
                                    newFieldObj.link = self.rawFieldValue(linkKey)[0];
                                }
                            }
                        }
                    }
                    return newFieldObj;
                },

                // Creating new multiple field
                newMultipleField: function (dataKey, separatorOverride) {
                    return this.newMultipleFieldWithLink(dataKey, null, separatorOverride)
                },

                // Creating new field with link object (previously called newFieldWithLink)
                newLinkField: function (dataKey, linkKey) {
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj) {
                        newFieldObj.link = self.rawFieldValue(linkKey);
                    }
                    return newFieldObj;
                },

                // Creating new URI field for either Principal or Corporate Business Models (previously called newFieldWithURI)
                newLinkBusinessModelField: function (dataKey, principalLinkKey, corporateLinkKey) {
                    if (self.isPrincipal()) {
                        return this.newLinkField(dataKey, principalLinkKey);
                    } else {
                        return this.newLinkField(dataKey, corporateLinkKey);
                    }
                },

                // Take two data keys and join - primaryDataKey should have the label
                newJoinField: function (primaryDataKey, secondaryDataKey, separatorOverride) {
                    var newFieldObj = this.newField(primaryDataKey);
                    var secondaryDataValue = self.rawFieldValue(secondaryDataKey);
                    if(self.rawFieldValuePresentAndNotEmpty(secondaryDataValue)){
                        newFieldObj.value += self.separator.personName(separatorOverride) + secondaryDataValue;
                    }
                    return newFieldObj;
                },

                // Take two data keys and join - primaryDataKey should have the label
                newLinkJoinField: function (primaryDataKey, secondaryDataKey, linkKey, separatorOverride) {
                    var newFieldObj = this.newLinkField(primaryDataKey, linkKey);
                    var secondaryDataValue = self.rawFieldValue(secondaryDataKey);
                    if(self.rawFieldValuePresentAndNotEmpty(secondaryDataValue)){
                        newFieldObj.value += self.separator.personName(separatorOverride) + secondaryDataValue;
                    }
                    return newFieldObj;
                },

                // Creating new organisation field - rule for following tiles:
                // Booking
                // Timesheet
                // Expense Claim
                // Candidate Submission
                // Perm Start Conf
                newOrganisationField: function (organisationUnitKey, organisationKey, separatorOverride) {
                    var newFieldObj = this.newField(organisationUnitKey);
                    if(newFieldObj) {
                        //prepend the organisation name to Org Unit
                        var organisation = self.rawFieldValue(organisationKey);
                        if(self.rawFieldValuePresentAndNotEmpty(organisation)){
                            newFieldObj.value = organisation + self.separator.list(separatorOverride) + newFieldObj.value;
                        }
                    }
                    return newFieldObj;
                },

                // Creating new organisation field - rule for following tiles:
                // Audit Pack
                // Distribution
                // Item
                // Order
                newOrganisationFieldWithLink: function (organisationUnitKey, organisationKey, linkKey, separatorOverride) {
                    var newFieldObj = this.newField(organisationUnitKey);
                    if(linkKey) {
                        var link = self.rawFieldValue(linkKey);
                    }
                    if(newFieldObj) {
                        //prepend the organisation name to Org Unit for non principal tiles
                        var organisation = self.rawFieldValue(organisationKey);
                        if(self.rawFieldValuePresentAndNotEmpty(organisation)){
                            newFieldObj.value = organisation + self.separator.list(separatorOverride) + newFieldObj.value;
                        }
                        if(linkKey){
                            newFieldObj.link = link;
                        }
                    }
                    return newFieldObj;
                },

                //Show decimals places for anything that is not per annum
                showDecimalPlaces: function(unitId){
                    return (self.LOOKUP_VALUE.PAY_TYPE_PER_ANNUM!==unitId);
                },

                // Creating new field rate per unit object
                newRatePerUnitField: function (dataKey, unitId, unit, nullToZero) {
                    self.setRawFieldValueToZero(dataKey, nullToZero);
                    var newFieldObj = this.newField(dataKey);
                    if(newFieldObj) {
                        var showDecimalPlaces = this.showDecimalPlaces(unitId);
                        newFieldObj.value = ratePerUnit(newFieldObj.value, showDecimalPlaces, unit, self.requesterData.currencySymbol);
                    }
                    return newFieldObj;
                },

                // Lighter version of above which handles collecting the lookup values
                newRatePerUnitFieldLite: function (valueDataKey, typeDataKey, nullToZero) {
                    var unit = self.lookupField(typeDataKey);
                    return this.newRatePerUnitField(valueDataKey, unit.id, unit.value, nullToZero);
                },

                // Lighter version of above which handles collecting the lookup values
                newRatePerUnitRangeFieldLite: function (valueFromDataKey, valueToDataKey, typeDataKey, nullToZero, separatorOverride) {
                    var unit = self.lookupField(typeDataKey);
                    var newFieldFromObj = this.newRatePerUnitField(valueFromDataKey, unit.id, nullToZero);
                    var newFieldToObj = this.newRatePerUnitField(valueToDataKey, unit.id, unit.value, nullToZero);

                    var from = self.rawFieldValue(valueFromDataKey);
                    var to = self.rawFieldValue(valueToDataKey);
                    if(from !== to) {
                        newFieldToObj.value = newFieldFromObj.value + self.separator.range(separatorOverride) + newFieldToObj.value;
                    }
                    return newFieldToObj;
                },

                // Creating new field rate per unit object
                newValueAndTypeField: function (valueDataKey, typeDataKey, separatorOverride) {
                    var newFieldObj = this.newField(valueDataKey);
                    if(newFieldObj) {
                        var lookupField = self.lookupField(typeDataKey);
                        if(lookupField) {
                            newFieldObj.value += self.separator.valueAndType(separatorOverride) + lookupField.value;
                        }
                    }
                    return newFieldObj;
                },

                // Creating new progress bar field object
                newProgressBarField: function (dataKey, additionalInfoKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    // Add lookup value to new fields value if lookup key exists
                    if (self.rawFieldValuePresentAndNotEmpty(rawFieldValue)) {
                        var fieldLabel = self.objectFieldLabel(dataKey);
                        var additionalInfoKeyLabel = self.objectFieldLabel(additionalInfoKey);
                        return {
                            label: fieldLabel,
                            additionalInfo: additionalInfoKeyLabel,
                            value: rawFieldValue.displayValue,
                            progressBar: {
                                min: rawFieldValue.min,
                                max: rawFieldValue.max,
                                now: rawFieldValue.now,
                                percentage: rawFieldValue.percentage
                            }
                        };
                    } else {
                        console.warn('Warning: Missing dataKey "' + dataKey + '" in dataList, cannot use newField method');
                    }
                },

                // Displays stars filled in or not based upon provided model
                newStarRatingField: function(dataKey, additionalInfoKey, noMatchKey, scoreDetailsUrlKey){
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    // Add lookup value to new fields value if lookup key exists
                    if (self.rawFieldValuePresentAndNotEmpty(rawFieldValue)) {
                        var fieldLabel = self.objectFieldLabel(dataKey);
                        if (rawFieldValue.now === 0) {
                            var noMatchKeyLabel = noMatchKey ? self.objectFieldLabel(noMatchKey) : 'No match';
                            return {
                                label: fieldLabel,
                                value: noMatchKeyLabel
                            };
                        } else {
                          const scoreDetailsUrl = scoreDetailsUrlKey ? self.rawFieldValue(scoreDetailsUrlKey) : '';
                          const starRatingField = {
                            label: fieldLabel,
                            starRating: {
                              min: rawFieldValue.min,
                              max: rawFieldValue.max,
                              now: rawFieldValue.now
                            },
                            scoreDetailsUrl: scoreDetailsUrl
                          };
                          return starRatingField;
                        }
                    } else {
                        console.warn('Warning: Missing dataKey "' + dataKey + '" in dataList, cannot use newField method');
                    }
                },

            };

            // Object that holds status creation methods
            this.status = {
                //
                basicStatus: function (rawFieldValue) {
                    return {
                        label: rawFieldValue,
                        class: self.CSS_CLASS.DEFAULT,
                        primaryId: rawFieldValue.id ? rawFieldValue.id : rawFieldValue,
                        secondaryId: undefined
                    }
                },
                // Alters the status class based upon if the id is present in the array passed
                alterStatusClass: function (idArray, status, cssClass) {
                    if(idArray) {
                        if( status.secondaryId===undefined && idArray.includes(status.primaryId)){
                            status.class = cssClass;
                        } else if( status.secondaryId!==undefined ){
                            idArray.forEach(function(array) {
                                if( array[0] === status.primaryId && array[1] === status.secondaryId ){
                                    status.class = cssClass;
                                }
                            });
                        }
                    }
                },
                //
                addLookupLabel: function(rawFieldValue, status, isSecondary, separatorOverride){
                    var rangeSeparator = self.separator.range(separatorOverride);
                    if(rawFieldValue && rawFieldValue.hasOwnProperty("lookupKey")){
                        if (rawFieldValue.id){
                            if(!isSecondary) {
                                status.label = self.lookupValues[rawFieldValue.lookupKey][rawFieldValue.id];
                            } else {
                                status.label += rangeSeparator + self.lookupValues[rawFieldValue.lookupKey][rawFieldValue.id];
                            }
                        }
                    } else if(isSecondary && rawFieldValue) {
                        status.label += rangeSeparator + rawFieldValue;
                    }
                },
                // Creating default status object
                newStatus: function (dataKey, positiveIdArray, negativeIdArray, warningIdArray) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    if(self.rawFieldValuePresent(rawFieldValue)){
                        if(self.rawFieldValueNotEmpty(rawFieldValue)){
                            var status = this.basicStatus(rawFieldValue);
                        }
                        this.alterStatusClass(positiveIdArray, status, self.CSS_CLASS.SUCCESS);
                        this.alterStatusClass(negativeIdArray, status, self.CSS_CLASS.DANGER);
                        this.alterStatusClass(warningIdArray, status, self.CSS_CLASS.WARNING);
                        // Add lookup value to new status label if lookup key exists
                        this.addLookupLabel(rawFieldValue, status, false);
                        return status;
                    }
                },
                newStatusWithHelp: function (dataKey, helpKey, positiveIdArray, negativeIdArray, warningIdArray) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var rawHelpValue = self.rawFieldValue(helpKey);
                    if(self.rawFieldValuePresent(rawFieldValue)){
                        if(self.rawFieldValueNotEmpty(rawFieldValue)){
                            var status = this.basicStatus(rawFieldValue);
                        }
                        status.additionalInfo = rawHelpValue;
                        this.alterStatusClass(positiveIdArray, status, self.CSS_CLASS.SUCCESS);
                        this.alterStatusClass(negativeIdArray, status, self.CSS_CLASS.DANGER);
                        this.alterStatusClass(warningIdArray, status, self.CSS_CLASS.WARNING);
                        // Add lookup value to new status label if lookup key exists
                        this.addLookupLabel(rawFieldValue, status, false);
                        return status;
                    }
                },
                newStatusWithHelpAndClassCode: function (dataKey, helpKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var rawHelpValue = self.rawFieldValue(helpKey);
                    if(rawFieldValue && self.rawFieldValuePresent(rawFieldValue)){
                        if(self.rawFieldValueNotEmpty(rawFieldValue)){
                            var status = this.basicStatus(rawFieldValue);
                            status.additionalInfo = rawHelpValue;
                            if (rawFieldValue.classCode){
                                status.class = rawFieldValue.classCode;
                            }

                            // Add lookup value to new status label if lookup key exists
                            this.addLookupLabel(rawFieldValue, status, false);
                            return status;
                        }
                    }
                },
                newFinancialActivtyStatus: function (dataKey,linkKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    if(self.rawFieldValuePresent(rawFieldValue)){
                        if(self.rawFieldValueNotEmpty(rawFieldValue)){
                            var status = this.basicStatus(rawFieldValue);
                            status.class = self.CSS_CLASS.SUCCESS;
                        }
                       if(status!=null) {
                         status.link = self.rawFieldValue(linkKey);
                        }
                        return status;
                    }
                },
                // Creating status object with 2 data keys to check
                newCombinedStatus: function (dataKey, secondDataKey, positiveIdArray, negativeIdArray, warningIdArray) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var rawFieldValue2 = self.rawFieldValue(secondDataKey);
                    if(rawFieldValue){
                        var status = this.basicStatus(rawFieldValue);
                        if(rawFieldValue2){
                            status.secondaryId = rawFieldValue2.id ? rawFieldValue2.id : rawFieldValue2;
                        }
                        this.alterStatusClass(positiveIdArray, status, self.CSS_CLASS.SUCCESS);
                        this.alterStatusClass(negativeIdArray, status, self.CSS_CLASS.DANGER);
                        this.alterStatusClass(warningIdArray, status, self.CSS_CLASS.WARNING);
                        this.addLookupLabel(rawFieldValue, status, false);
                        this.addLookupLabel(rawFieldValue2, status, true);
                        return status;
                    }
                },
                // Creating status object with 2 data keys to check with help text
                newCombinedStatusWithHelp: function (dataKey, secondDataKey, helpKey, positiveIdArray, negativeIdArray, warningIdArray) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var rawFieldValue2 = self.rawFieldValue(secondDataKey);
                    var rawHelpValue = self.rawFieldValue(helpKey);
                    if(rawFieldValue){
                        var status = this.basicStatus(rawFieldValue);
                        if(rawFieldValue2){
                            status.secondaryId = rawFieldValue2.id ? rawFieldValue2.id : rawFieldValue2;
                        }
                        status.additionalInfo = rawHelpValue;
                        this.alterStatusClass(positiveIdArray, status, self.CSS_CLASS.SUCCESS);
                        this.alterStatusClass(negativeIdArray, status, self.CSS_CLASS.DANGER);
                        this.alterStatusClass(warningIdArray, status, self.CSS_CLASS.WARNING);
                        this.addLookupLabel(rawFieldValue, status, false);
                        this.addLookupLabel(rawFieldValue2, status, true);
                        return status;
                    }
                },

                // Creating framework status object
                newFrameworkStatus: function (dataKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    if(rawFieldValue){
                        var newFieldObj = this.newStatus(dataKey);
                        newFieldObj.label = self.objectFieldLabel(dataKey);
                        newFieldObj.additionalInfo = rawFieldValue;
                        return newFieldObj;
                    }
                },

                // Creating status with help icon and styling
                newStatusWithInfoAndStyling: function (dataKey, helpKey, positiveIdArray, negativeIdArray, warningIdArray) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var rawHelpValue = self.rawFieldValue(helpKey);
                    if(rawFieldValue){
                        var status = this.newStatus(dataKey);
                        this.alterStatusClass(positiveIdArray, status, self.CSS_CLASS.SUCCESS);
                        this.alterStatusClass(negativeIdArray, status, self.CSS_CLASS.DANGER);
                        this.alterStatusClass(warningIdArray, status, self.CSS_CLASS.WARNING);
                        status.additionalInfo = rawHelpValue;
                        return status;
                    }
                },

              newStatusWithInfoAndStylingAndPrefix: function (dataKey, helpKey, prefix, positiveIdArray, negativeIdArray, warningIdArray) {
                var status = this.newStatusWithInfoAndStyling(dataKey, helpKey, positiveIdArray, negativeIdArray, warningIdArray)
                status.label = prefix + status.label;
                return status;
              },

                newLabelStatus: function (dataKey,helpKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var rawHelpValue = helpKey
                    if(rawFieldValue){
                        var newFieldObj = this.newStatus(dataKey);
                        newFieldObj.label = self.objectFieldLabel(dataKey);
                        if(dataKey=='invalidEmailStatus'){
                            newFieldObj.class = self.CSS_CLASS.DANGER;
                        }else if(dataKey=='targetClient' || dataKey=='focusManager'){
                            newFieldObj.class = self.CSS_CLASS.SUCCESS;
                            newFieldObj.label = rawFieldValue;
                        }else if(dataKey=='multinational'){
                            newFieldObj.class = self.CSS_CLASS.INFO;
                        }else{
                            newFieldObj.class = self.CSS_CLASS.WARNING;
                        }
                        if(rawHelpValue){
                            newFieldObj.additionalInfo = self.objectTilesLabels[helpKey].label;
                        }
                        return newFieldObj;
                    }
                },

                 newLabelStatusWithClass: function (dataKey,helpKey,cssKey) {
                     var rawFieldValue = self.rawFieldValue(dataKey);
                     var rawHelpValue = helpKey
                     if(rawFieldValue){
                         var newFieldObj = this.newStatus(dataKey);
                         newFieldObj.label = rawFieldValue;
                         if (cssKey) {
                             newFieldObj.class = self.rawFieldValue(cssKey);
                         }
                         if(rawHelpValue){
                             newFieldObj.additionalInfo = self.objectTilesLabels[helpKey].label;
                             if(rawHelpValue=='focusManagerHelpText'){
                                 newFieldObj.additionalInfo = self.rawFieldValue(helpKey);
                             }
                         }
                         return newFieldObj;
                     }
                 },

                //assumes positive number good and 0 and negative number bad
                newLabelAndNumericValueStatus: function(dataKey, separatorOverride){
                    var newFieldObj = this.newStatus(dataKey);
                    if(newFieldObj){
                        var label = self.objectFieldLabel(dataKey);
                        var rawFieldValue = self.rawFieldValue(dataKey);
                        var keyValueSeparator = self.separator.keyValue(separatorOverride);
                        newFieldObj.label = label + keyValueSeparator + rawFieldValue;
                        newFieldObj.class = rawFieldValue>0 ? self.CSS_CLASS.SUCCESS : self.CSS_CLASS.WARNING;
                    }
                    return newFieldObj;
                },

                // Creating entitlement to work status object
                newLabelAndBooleanValueStatus: function (dataKey, separatorOverride) {
                    var newFieldObj = this.newStatus(dataKey);
                    if(newFieldObj){
                        var label = self.objectFieldLabel(dataKey);
                        var rawFieldValue = self.rawFieldValue(dataKey);
                        var keyValueSeparator = self.separator.keyValue(separatorOverride);
                        newFieldObj.label = (rawFieldValue ? label + keyValueSeparator + self.commonLabels.booleanYes.label : label + keyValueSeparator + self.commonLabels.booleanNo.label);
                        newFieldObj.class = rawFieldValue ? self.CSS_CLASS.SUCCESS : self.CSS_CLASS.DEFAULT;
                    }
                    return newFieldObj;
                },

                // Creating boolean or hide status object
                newTrueBooleanOrHide: function (dataKey, status){
                    var newFieldObj = this.newStatus(dataKey);
                    if (newFieldObj){
                        newFieldObj.label = self.objectFieldLabel(dataKey);
                        if (!self.rawFieldValue(dataKey)){
                            newFieldObj.class = self.CSS_CLASS.HIDDEN;
                        }else{
                            if(status){
                                newFieldObj.class = status
                            }
                            return newFieldObj;
                        }
                    }
                },

                // Creating boolean or hide status object
                newStatusWithState: function (dataKey, status){
                    var newFieldObj = this.newStatus(dataKey);
                    if (newFieldObj){
                        newFieldObj.label = self.objectFieldLabel(dataKey);
                        if (!self.rawFieldValue(dataKey)){
                            newFieldObj.class = self.CSS_CLASS.HIDDEN;
                        }else if(status){
                            newFieldObj.class = status
                        }
                        return newFieldObj;
                    }
                },

                // Creating status object joining with the label
                // E.g.: dataKey - Temp, lookupKey - alwaysRecruiting, return value : Temp - lookup value for lookupKey(alwaysRecruiting)
                newStatusWithLookup: function (dataKey, lookupKey, separatorOverride){
                    var newFieldObj = this.newStatus(dataKey);
                    if (newFieldObj){
                        newFieldObj.label = newFieldObj.label + self.separator.range(separatorOverride) + self.objectFieldLabel(lookupKey);
                        return newFieldObj;
                    }
                },

                newStatusIcon: (dataKey, path, icon, additionalInfo = '') => {
                    let newFieldObj = this.status.newStatus(dataKey)
                    if (newFieldObj) {
                        newFieldObj = this.addIcon(path, icon, newFieldObj)
                        newFieldObj.additionalInfo = additionalInfo
                        newFieldObj.label = undefined
                        return newFieldObj
                    }
                },
            };

            // Object that holds stage collection methods
            this.stageCollection = {

                // Creating default status object
                newStageCollection: function (dataKey) {
                    var stageCollectionLabel;
                    var stageCollectionData = [];
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    if(rawFieldValue) {
                        var lookupList = self.lookupValues[rawFieldValue.lookupKey];
                        if(lookupList) {
                            stageCollectionLabel = self.objectFieldLabel(dataKey);
                            rawFieldValue.orderedData.forEach(function (data) {
                                stageCollectionData.push({
                                    label: lookupList[data.id],
                                    status: data.status
                                })
                            });
                        } else {
                            console.warn('WARNING: Unable to find a lookup list')
                        }
                    }
                    return {label: stageCollectionLabel, data: stageCollectionData};
                }
            };

            // Object that holds call to action methods
            this.callToAction = {
                // Creating call to action modal object
                newCallToActionModal: function (dataKey, linkKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var rawFieldLinkValue = self.rawFieldValue(linkKey);
                    if(rawFieldValue || rawFieldLinkValue){
                        var callToActionLabel = self.objectFieldLabel(dataKey);
                        return {label: callToActionLabel, link: rawFieldLinkValue};
                    }
                }
            };

            // Object that holds the search match flag data
            this.searchMatchFlag = {
                // Creating search match flag object
                newSearchMatchFlag: function (dataKey, additionalInfoKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    var labelLookupField = self.lookupField(dataKey);
                    var additionalInfoLookupField = self.lookupField(additionalInfoKey);

                    var searchMatchFlagObject = {};

                    if(rawFieldValue || labelLookupField || additionalInfoLookupField){
                        searchMatchFlagObject.id = rawFieldValue ? rawFieldValue.id : null;
                        searchMatchFlagObject.label = labelLookupField ? labelLookupField.value : null;
                        searchMatchFlagObject.additionalInfo = additionalInfoLookupField ? additionalInfoLookupField.value : null;
                    }
                    return searchMatchFlagObject
                }
            };

            // Object that holds text field methods
            this.textField = {
                // Creating text field
                newTextField: function (dataKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    if(rawFieldValue){
                        var htmlValue = rawFieldValue;
                        var sanitizedServerSide = false;
                        if(rawFieldValue.sanitized) {
                            sanitizedServerSide = true;
                            htmlValue = rawFieldValue.sanitizedHTML
                        }
                        var textFieldLabel = self.objectFieldLabel(dataKey);
                        return {label: textFieldLabel, value: htmlValue, sanitizedServerSide: sanitizedServerSide};
                    }
                }
            };

            // Object that holds history timestamp methods
            this.historyTimeStamp = {
                // Creating text field
                newHistoryTimeStamp: function (dataKey) {
                    var rawFieldValue = self.rawFieldValue(dataKey);
                    if(rawFieldValue){
                        var textFieldLabel = self.objectFieldLabel(dataKey);
                        return {label: textFieldLabel, value: rawFieldValue, ago: timeAgo(rawFieldValue)};
                    }
                }
            };

            // X3-30371
            function timeAgo(date) {
                const now = new Date();
                const seconds = Math.floor((now - new Date(date)) / 1000);

                const intervals = {
                    year: 31536000,
                    month: 2592000,
                    // week: 604800,
                    day: 86400,
                    hour: 3600,
                    minute: 60,
                    second: 1
                };

                for (const [unit, value] of Object.entries(intervals)) {
                    const count = Math.floor(seconds / value);
                    if (count >= 1) {
                        var str = '';
                        if (count == 1) {
                            if (unit == 'hour') {
                                str += 'an'
                            } else {
                                str += 'a'
                            }
                        } else {
                            str += `${count}`
                        }
                        str += ` ${unit}${count > 1 ? 's' : ''} ago`;

                        return str;
                    }
                }

                return 'just now';
            }

            // A reference to the constant
            this.LOOKUP_VALUE = LOOKUP_VALUE;
        };
        const LOOKUP_VALUE = {
                AVAILABILITY_AVAILABLE:719,
                AVAILABILITY_IN_BOOKING_TEMP:722,
                AVAILABILITY_IN_BOOKING_PERM: 532735,
                AVAILABILITY_NOT_LOOKING_FOR_WORK:721,
                AVAILABILITY_PROSPECTIVE:5364,
                AVAILABILITY_RTFS:5852,
                AVAILABILITY_STOPPED:434496,
                DISTRIBUTION_STATUS_AWAITING_CLAIM:393,
                DISTRIBUTION_STATUS_CLAIMED:520,
                DISTRIBUTION_STATUS_CLOSED:394,
                DISTRIBUTION_STATUS_FILLED:521,
                DISTRIBUTION_STATUS_PAUSED:391,
                DISTRIBUTION_STATUS_REJECTED:392,
                ITEM_STATUS_CLOSED:213,
                ITEM_STATUS_DRAFT:210,
                ITEM_STATUS_OPEN:211,
                ITEM_STATUS_PAUSED:212,
                ITEM_STATUS2_AWAITING_AUTH:215,
                ITEM_STATUS2_CANCELLED:774,
                ITEM_STATUS2_COMPLETED:611,
                ITEM_STATUS2_DISTRIBUTED:398,
                ITEM_STATUS2_IN_PROGRESS:6088,
                ITEM_STATUS2_BOOKING_AWAITING_START:6089,
                ITEM_STATUS2_SUBMISSIONS:6090,
                ITEM_STATUS2_POSTED:6091,
                ITEM_STATUS2_INTERVIEWING:6092,
                ITEM_STATUS2_INACTIVE:6093,
                ITEM_STATUS2_DRAFT:621721,
                ITEM_STATUS2_FILLED:400,
                ITEM_STATUS2_PART_FILLED:399,
                ITEM_STATUS2_PLACED:214,
                ITEM_STATUS2_PROCESSED:216,
                ITEM_STATUS2_REJECTED:217,
                ITEM_TYPE_INTERIM_POSITION:208,
                ITEM_TYPE_INTERIM_PERMANENT_POSITION:295,
                ITEM_TYPE_PERMANENT_POSITION:209,
                ITEM_TYPE_TEMP_TO_PERM:4832,
                MANAGER_STATUS_JOB:5082,
                MANAGER_STATUS_BOOKING:5084,
                MANAGER_STATUS_LAPSED:5120,
                MANAGER_STATUS_LEFT:5086,
                MANAGER_STATUS_PROSPECTIVE:5081,
                MANAGER_STATUS_STOPPED:5085,
                PAY_TYPE_PER_ANNUM:320,
                PAY_TYPE_PER_DAY:321,
                PAY_TYPE_PER_HOUR:322,
                BOOKING_STATUS_OPEN:576,
                BOOKING_STATUS_CLOSED:583,
                INTERVIEW_STATUS_REQUESTED:4680,
                INTERVIEW_STATUS_CONFIRMED:4681,
                INTERVIEW_STATUS_CANCELLED:4682,
                INTERVIEW_STATUS_COMPLETED:4683,
                INTERVIEW_STATUS_REJECTED:4684,
                CREDIT_STATUS_PROSPECTIVE:5229,
                CREDIT_STATUS_RESTRICTED:5230,
                CREDIT_STATUS_APPROVED:5231,
                CREDIT_STATUS_STOP_LISTED:5232,
                PERM_START_CONFIRMATION_AWAITING_AUTHORISATION:533,
                PERM_START_CONFIRMATION_AWAITING_RESUBMISSION:534,
                PERM_START_CONFIRMATION_AWAITING_REPOST_FINANCIALS:535,
                PERM_START_CONFIRMATION_REJECTED:536,
                PERM_START_CONFIRMATION_AUTHORISED:537,
                PERM_START_CONFIRMATION_CANCELLED:4826,
                PERM_START_CONFIRMATION_AWAITING_REPOST_ALLOCATION:4827,
                PERM_START_CONFIRMATION_IN_REVIEW:4953,
                PERM_START_CONFIRMATION_PROCESSING:4954,
                PERM_START_CONFIRMATION_AWAITING_OVERTIME_AUTHORISATION:5161,
                PERM_START_CONFIRMATION_REVERSED:5276,
                PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_ALLOCATION:5397,
                PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_FINANCIALS:5398,
                BUSINESS_STATUS_PROSPECTIVE:5053,
                BUSINESS_STATUS_JOB:5054,
                BUSINESS_STATUS_BOOKING:5056,
                BUSINESS_STATUS_STOPPED:5057,
                BUSINESS_STATUS_LAPSED:5119,
                BOOKING_REQUESTED:577,
                BOOKING_AWAITING_START:578,
                BOOKING_REJECTED:579,
                BOOKING_IN_PROGRESS:580,
                BOOKING_CANCELLED:581,
                BOOKING_COMPLETED:582,
                CANDIDATE_SUBMISSION_SHORTLIST:642,
                CANDIDATE_SUBMISSION_OPEN:643,
                CANDIDATE_SUBMISSION_WITHDRAWN:644,
                CANDIDATE_SUBMISSION_REJECTED:645,
                CANDIDATE_SUBMISSION_CLOSED:646,
                CANDIDATE_SUBMISSION_CANDIDATE_APPLICATION:5354,
                CANDIDATE_SUBMISSION_IN_REVIEW:5356,
                CANDIDATE_SUBMISSION_BOOKED:5357,
                CANDIDATE_SUBMISSION_INTERVIEW:5358,
                CANDIDATE_SUBMISSION_APPLICATION_REJECTED:5384,
                CANDIDATE_SUBMISSION_PROSPECTIVE:5529,
                CANDIDATE_SUBMISSION_APPLICATION_SHORTLISTED:5922,
                SCREENING_CHECKITEM_OPEN:5410,
                SCREENING_CHECKITEM_SUBCHECK_COMP:5411,
                SCREENING_CHECKITEM_CLOSED_SUCC:5412,
                SCREENING_CHECKITEM_CLOSED_FAIL:5413,
                SCREENING_SUBCHECK_REQ:5414,
                SCREENING_SUBCHECK_COMPLETE_PASS:5415,
                SCREENING_SUBCHECK_COMPLETE_FAIL:5416,
                SCREENING_SUBCHECK_COMPLETE_DISC:5417,
                SCREENING_SUBCHECK_INPROGRESS:434422,
                AUTOMATED_SEARCH_UNSEEN:5329,
                AUTOMATED_SEARCH_NO_UNSEEN:5330,
                CLIENT_MEETING_ARRANGED:533295,
                CLIENT_MEETING_ATTENDED:533296,
                CLIENT_MEETING_CANCELLED:533297,
                LEAD_SUCCESS:6129,
                LEAD_CLOSED:6130,
                LEAD_ASSIGNED:655034,
                LEAD_UNASSIGNED:655035,
                VENDOR_STATUS_ACTIVE: 6630,
                VENDOR_STATUS_DRAFT: 6629,
                OFFER_STATUS_DRAFT:6235,
                OFFER_STATUS_IN_REVIEW:6236,
                OFFER_STATUS_OFFER_MADE:6237,
                OFFER_STATUS_ACCEPTED:6238,
                OFFER_STATUS_REJECTED:6239,
                OFFER_STATUS_WITHDRAWN:6240

            };

        // Object specific subtitle mapping
        function mapSubTitle(rawTileData){
            var tileSubTitle;
            if(rawTileData.type.toLowerCase() === "candidate"){
                tileSubTitle = (rawTileData.currentPreviousJobTitle ? rawTileData.currentPreviousJobTitle : rawTileData.desiredJobTitle);
            }
            return tileSubTitle;
        }

        // Data normalisation function
        function normalize(value){
            return angular.isDefined(value) && value!==null ? value : undefined;
            // not sure yet if I want undefined or ''. undefined seems to be better as it can be tested against easier and it's degraded to '' on output
        }

        // Date time conversion
        function dateTime(datetime, dateFormat) {
            if(dateFormat){
                return normalize(datetime) ? $filter('date')(datetime,"EEE " + dateFormat + " HH:mm") : undefined;
            } else {
                return normalize(datetime) ? $filter('date')(datetime,"EEE dd/MM/yyyy HH:mm") : undefined;
            }
            // maybe some more tests (if conditions) here ie. if datatime is an javascript Date object etc... (can throw exception if now)
            // "EEE dd/MM/yyyy HH:mm" is something what should be pulled from some kind of country config
        }

        function date(date, dateFormat) {
            if(dateFormat){
                return normalize(date) ? $filter('date')(date,"EEE " + dateFormat) : undefined;
            } else {
                return normalize(date) ? $filter('date')(date,"EEE dd/MM/yyyy") : undefined;
            }
            // maybe some more tests (if conditions) here ie. if datatime is an javascript Date object etc... (can throw exception if now)
            // "EEE dd/MM/yyyy HH:mm" is something what should be pulled from some kind of country config
        }

        // Capitalisation (first letter)
        function capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        // Rate per unit formatting
        function ratePerUnit(rate, showDecimalPlaces, unit, currencySymbol) {
            var decimalPlaces = showDecimalPlaces ? 2 : 0;
            var rateWithCurrency = $filter('currency')(rate, currencySymbol, decimalPlaces);
            return (rateWithCurrency ? rateWithCurrency + ' ' + (unit ? unit : '') : '');
        }

        return {
            constructTileData : constructTileData, HISTORY_TILE: HISTORY_TILE
        };
    };

    tileDataFactory.$inject = ['$filter'];
    angular.module('app').factory('tileDataFactory', tileDataFactory);

}());
